import { getAppDomain, getContentType, getDeployRegion, getLanguae, getSearchCountry } from 'common/util'
import { has, omit } from 'lodash'
import request, { ResponseData } from './request'

const Omits = ['createdAt', 'locale', 'pn', 'publishedAt', 'updatedAt', 'steps']
export interface IAction {
  id: number
  title: string
  url: string
  extra?: {
    [k: string]: any
  }
}

export interface IStep {
  banner?: string
  YoutubeUrl?: string
  content: string
  action_sheets: Array<IAction>
  buttons: Array<IAction>
}

export interface IDocument {
  title: string
  feedback: boolean
  steps: IStep[]
  id: number
}

interface GetDocumentResponse {
  data: {
    data: {
      id: number
      attributes: {
        title: string
        feedback: boolean
        steps: Array<{
          banner?: {
            data: {
              attributes: {
                url: string
              }
            }
          }
          YoutubeUrl?: string
          content: string
          action_sheets: Array<{
            id: number
            title: string
            url: string
          }> | null
          buttons: Array<{
            id: number
            title: string
            url: string
          }> | null
        }>
      }
    }
  }
}

const getDocument = async (uid: string, id: string) => {
  const content_type = await getContentType()
  const lang = getLanguae()
  const country = getSearchCountry()
  const DEPLOY_REGION = getDeployRegion()

  // const link =
  //   DEPLOY_REGION === 'CN'
  //     ? `${await getAppDomain()}/v1/cms_service/cms/product/wiki/detail`
  //     : `${await getAppDomain()}/v1/shopping/cms/product/wiki/detail/1.1.0`

  // 先回到老的接口，中区目前暂不支持新接口
  // const link = `${await shoppingService()}/cms/product/wiki/detail/1.1.0`
  // 在mega上面不需要鉴权 ，所以调用security的host
  const link = `${await getAppDomain()}/v1/shopping/cms/product/wiki/detail/1.1.0`
  // const method = DEPLOY_REGION === 'US' ? 'GET' : 'POST'
  const method = 'GET'

  const _params = { uid:uid??'', content_type: content_type.document, lang, country,id }
  // const getParams = DEPLOY_REGION === 'US' ? _params : undefined
  const postParams = DEPLOY_REGION === 'US' ? undefined : _params

  const getParams = _params

  return request<ResponseData<GetDocumentResponse>>(
    link,
    {
      method,
      params: getParams,
      data: postParams,
    },
    {
      ignoreAuthToken: true,
    }
  )
    .then(res => {
      if (res.code === 0 && has(res, 'data.data.data.attributes')) {
        return res.data.data.data.attributes
      } else {
        return Promise.reject(null)
      }
    })
    .then(res => {
      const steps = res.steps.map((step: { banner: { data: { attributes: { url: any } } } }) => {
        const banner = step.banner.data?.attributes.url
        return { ...step, banner }
      })
      return { steps, ...omit(res, Omits) } as IDocument
    })
}

export default getDocument
